var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cancel 3",
    clipPath: "url(#clip0_124_19487)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.54193 6.99955L13.7763 1.76491C13.9203 1.62081 13.9998 1.42857 14 1.22358C14 1.01847 13.9206 0.826 13.7763 0.68213L13.3176 0.223545C13.1734 0.0791057 12.9812 0 12.776 0C12.5711 0 12.3788 0.0791057 12.2346 0.223545L7.00023 5.45784L1.76559 0.223545C1.62161 0.0791057 1.42925 0 1.22415 0C1.01927 0 0.826911 0.0791057 0.682927 0.223545L0.224 0.68213C-0.0746667 0.980797 -0.0746667 1.46659 0.224 1.76491L5.45852 6.99955L0.224 12.234C0.0799024 12.3783 0.000569106 12.5705 0.000569106 12.7755C0.000569106 12.9805 0.0799024 13.1728 0.224 13.317L0.682813 13.7756C0.826797 13.9199 1.01927 13.9991 1.22403 13.9991C1.42914 13.9991 1.6215 13.9199 1.76548 13.7756L7.00011 8.54114L12.2345 13.7756C12.3787 13.9199 12.571 13.9991 12.7759 13.9991H12.7761C12.9811 13.9991 13.1733 13.9199 13.3175 13.7756L13.7762 13.317C13.9202 13.1729 13.9997 12.9805 13.9997 12.7755C13.9997 12.5705 13.9202 12.3783 13.7762 12.2341L8.54193 6.99955Z",
    fill: "#C0C0C0"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_124_19487"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.3b85cbbd3b93e80de4b769193bad8e01.svg";
export { ForwardRef as ReactComponent };